import script from "./IAcquiringsButton.vue?vue&type=script&setup=true&lang=js"
export * from "./IAcquiringsButton.vue?vue&type=script&setup=true&lang=js"

import "./IAcquiringsButton.vue?vue&type=style&index=0&id=080072de&scoped=true&lang=scss"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-080072de"]])

export default __exports__